<template>
    <div class="modal modal-bg" :class="{ show: open }">
        <modal v-if="open" modal-with-card card-classes="md-card-login" @close="closeModal"
               type="modal-container md-layout-item md-xsmall-size-100 md-small-size-90 md-medium-size-80 md-large-size-60 md-xlarge-size-50 mx-auto p-0">
            <template #header>
                <md-card-header class="md-card-header-cyan m-0">
                    <md-button class="md-simple md-close md-white md-just-icon md-round modal-card-button mt-10" @click="closeModal">
                        <md-icon class="opacity-100">{{ $t("icon.clear") }}</md-icon>
                    </md-button>
                    <h4 class="card-title mt-0">Main Screen</h4>
                </md-card-header>
            </template>

            <template #body>
                <div class="section pb-0 pl-15 pr-15">
                    <main-screen-form @saved="onSaved" />
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
import Modal from "@/components/Modal.vue";
import MainScreenForm from "@/views/settings/MainScreenForm.vue";

export default {
    name: "ModalMainScreen",
    components: { Modal, MainScreenForm },
    props: {
        open: Boolean,
    },
    methods: {
        onSaved() {
            this.$emit("saved");
            this.$emit("close");
        },
        closeModal() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
::v-deep .md-layout .md-layout-item:nth-child(2) {
    flex: 0 1 45% !important;
    max-width: 45% !important;
}
::v-deep .md-layout .md-layout-item:nth-child(3) {
    flex: 0 1 30% !important;
    max-width: 30% !important;
    justify-content: flex-end;
}
</style>
